import React from 'react'
import { useCallback } from 'react'
import { Box, Button, Text, useToast } from '@chakra-ui/react'
import { translator } from '../utils/translator'
import { ResendEmailVerificationSCN } from '../components/ResendEmailVerificationSCN'

export const useError = () => {
  const getErrorMessage = useCallback((err: any): any => {
    switch (err?.response?.data?.code) {
      case 'lab_limit_exceeded':
        return 'El limite de derivación para el estudio ha sido excedido'

      case 'active_investigation_already_exists':
        return 'El estudio ya tiene una investigación activa para este caso'

      case 'cannot_dismiss_accepted_report':
        return 'No puedes desestimar este informe aceptado porque existe otra investigación activa para este caso'

      case 'invalid_report_to_accept':
        return 'No es posible aceptar este informe porque no pertenece al último informe de la investigación'

      case 'invalid_report_to_reject':
        return 'No es posible rechazar este informe porque no pertenece al último informe de la investigación'

      case 'invalid_report_to_dismiss':
        return 'No es posible desestimar este informe porque no pertenece al último informe de la investigación'

      case 'cannot_delete_annex':
        return 'No es posible eliminar este anexo porque no pertenece al último informe de la investigación'

      case 'cannot_upload_annex':
        return 'No es posible subir este anexo porque no pertenece al último informe de la investigación'

      case 'limit_already_exists_for_user':
        return 'Ya existe un limite para el usuario'

      case 'case_responsible_count_exceeded':
        return `Se ha excedido el limite de responsables para el caso`

      case 'integration_not_found':
        return 'La integración no existe'

      case 'wrong_case_user':
        return 'El rol del usuario no permite realizar esta acción'

      case 'integration_invalid_credentials':
        return 'Las credenciales de la integración no son validas'

      case 'not_found_case_users':
        return 'Este caso no tiene un responsable o colaborador que pueda recibir la solicitud de novedades'

      case 'case_request_repeated':
        return 'Ya existe una solicitud de caso con el mismo numero de siniestro'

      case 'case_resync_in_progress':
        return 'El caso ya se está sincronizando. Si no avanza, vas a poder reintentar en unos minutos'

      case 'case_not_resyncable':
        return 'Este caso no se sincroniza con una integración'

      case 'incident_resync_until_in_future':
        return 'La fecha de corte de la resincronización tiene que ser anterior a ahora'

      case 'email_wrong_company_type':
        return 'El email ingresado pertenece a una empresa de otro tipo'

      case 'alert_name_duplicated':
        return 'Ya existe una alerta con este nombre'

      case 'contact_email_already_exists':
        return 'El email del estudio ya se encuentra registrado'

      case 'cannot_process_request':
        return 'No se ha podido procesar tu solicitud. Verifica el email y reintenta nuevamente'

      case 'not_found_agency':
        return 'El numero de siniestro tiene un código de agencia que no existe'

      case 'not_found_ramo':
        return 'El numero de siniestro tiene un código de ramo que no existe'

      case 'bad_credentials':
        return 'Usuario o contraseña incorrecto'

      case 'wrong_company_type':
      case 'not_found_user':
        return 'Credenciales invalidas'

      case 'ein_already_exists':
        return 'El CUIT ya existe actualmente en otra empresa'

      case 'name_already_exists':
        return 'El nombre ya existe actualmente en otra empresa'

      case 'email_already_exists':
        return 'El correo electrónico ya se encuentra en uso por otro usuario'

      case 'invitations_already_exists':
        return `${err.response?.data.errors
          .map((e: any) => e.email)
          .join(', ')} ya fueron invitados y su registro esta pendiente`

      case 'username_already_exists':
        return 'El nombre de usuario ya se encuentra en uso por otra persona'

      case 'emails_already_exists':
        return `${err.response?.data.errors
          .map((e: any) => e.email)
          .join(', ')} ya se encuentra registrado`

      case 'wrong_identity_email':
        return 'Tu correo electrónico no te permite formar parte de la empresa'

      case 'domain_already_exists':
        return 'El dominio ya existe actualmente en otra empresa'

      case 'invalid_credentials':
      case 'bad_credentials':
        return 'Usuario o contraseña incorrecto'

      case 'wrong_company_type':
      case 'not_found_user':
        return 'Credenciales invalidas'

      case 'ein_already_exists':
        return 'El CUIT ya existe actualmente en otra empresa'

      case 'name_already_exists':
        return 'El nombre ya existe actualmente en otra empresa'

      case 'email_already_exists':
        return 'El correo electrónico ya se encuentra en uso por otro usuario'

      case 'invitations_already_exists':
        return `${err.response?.data.errors
          .map((e: any) => e.email)
          .join(', ')} ya fueron invitados y su registro esta pendiente`

      case 'username_already_exists':
        return 'El nombre de usuario ya se encuentra en uso por otra persona'

      case 'emails_already_exists':
        return `${err.response?.data.errors
          .map((e: any) => e.email)
          .join(', ')} ya se encuentra registrado`

      case 'wrong_identity_email':
        return 'Tu correo electrónico no te permite formar parte de la empresa'

      case 'domain_already_exists':
        return 'El dominio ya existe actualmente en otra empresa'

      case 'integration_unavailable':
        return 'Integración no disponible por el momento. Intente mas tarde.'

      case 'integration_access_blocked':
        return 'El proveedor de la integración está bloqueando temporalmente las consultas automáticas. Intentá nuevamente en unos minutos.'

      case 'wrong_integration_connection_credentials':
        return 'Credenciales de integración invalidas.\n Asegúrate de que el usuario y contraseña sean correctos.'

      case 'not_found_integration_connection':
        'No se encontró la integración'

      case 'customer_identification_missing':
        'El asegurado no posee identificación'

      case 'integration_connection_failed':
        'Conexión con integración fallida'

      case 'user_not_verified':
        return (
          <Box>
            <Text>
              El usuario no ha sido verificado. Para ingresar, verifica tu
              email.
            </Text>
            <ResendEmailVerificationSCN
              resendToken={err?.response?.data?.resendToken}
            />
          </Box>
        )

      case 'contact_does_not_support_investigation_type':
        return `El estudio de investigación no soporta el tipo de investigación que se desea derivar`

      case 'email_wrong_company_type':
        return 'El email ingresado no corresponde a un estudio de investigación'

      case 'investigation_already_exists':
        return 'Ya existe una investigación activa para este caso'

      case 'invalid_identification':
        return 'El número de identificación no contiene un numero CUIL valido'

      case 'contact_email_already_exists':
        return 'El correo electrónico ya fue registrado en tus estudios asociados'

      case 'not_found_prices':
        return 'No se encontraron honorarios para el estudio seleccionado'
      case 'cannot_process_request':
        return 'No se ha podido procesar tu solicitud. Verifica el email y reintenta nuevamente'

      case 'not_found_agency':
        return 'El numero de siniestro tiene un código de agencia que no existe'

      case 'not_found_ramo':
        return 'El numero de siniestro tiene un código de ramo que no existe'

      case 'bad_credentials':
        return 'Usuario o contraseña incorrecto'

      case 'bad_credentials':
        return 'Usuario o contraseña incorrecto'

      case 'contact_already_existent':
        return 'El estudio de investigación ya existe dentro de tus contactos'

      case 'wrong_company_type':
      case 'not_found_user':
        return 'Credenciales invalidas'

      case 'ein_already_exists':
        return 'El CUIT ya existe actualmente en otra empresa'

      case 'name_already_exists':
        return 'El nombre ya existe actualmente en otra empresa'

      case 'email_already_exists':
        return 'El correo electrónico ya se encuentra en uso por otro usuario'

      case 'invitations_already_exists':
        return `${err.response?.data.errors
          .map((e: any) => e.email)
          .join(', ')} ya fueron invitados y su registro esta pendiente`

      case 'limit_already_exists_for_contact':
        return 'Ya existe un limite para los estudios seleccionados'

      case 'username_already_exists':
        return 'El nombre de usuario ya se encuentra en uso por otra persona'

      case 'emails_already_exists':
        return `${err.response?.data.errors
          .map((e: any) => e.email)
          .join(', ')} ya se encuentra registrado`

      case 'wrong_integration_connection_credentials':
        const [{ integration }] = err.response.data.errors
        return `Las credenciales de la integración ${translator(
          integration,
        )} no son validas. Cámbiala por unas credenciales validas.`

      case 'wrong_identity_email':
        return 'Tu correo electrónico no te permite formar parte de la empresa'

      case 'domain_already_exists':
        return 'El dominio ya existe actualmente en otra empresa'

      case 'contact_does_not_support_sinister_type':
        return 'El contacto no soporta el tipo de siniestro actual'

      case 'integration_connection_not_found':
        return 'No se encontró ninguna conexión de integración con Autoinspector para su usuario.'

      case 'case_invalid_status':
        return 'El estado del caso no permite realizar esta acción'

      case 'stop_case_request_already_exists':
        return 'Ya existe una solicitud de detención para este caso'

      case 'missing_ssn_information':
        return 'El caso no tiene información completa de SSN'

      case 'person_already_in_case':
        return 'La persona ya está asociada a este caso'

      case 'person_exists':
        return 'La persona ya existe en tu compañía pero no está asociada a este caso'

      case 'not_found_case_person':
        return 'No se encontró la persona en el caso o no fue agregada manualmente'

      case 'case_person_associated_to_ssn':
        return 'No es posible desvincular la persona porque está asociada a un reporte SSN'

      case 'bcra_daily_limit_reached':
        return 'Ya se pidió un informe BCRA para esta persona hoy. Intenta nuevamente mañana.'

      case 'not_found_claim':
        return 'No se encontró el reclamo en el caso'

      case 'case_has_claims_not_defined':
        return 'El caso no puede ser cerrado porque tiene reclamos sin resultado'
      case 'case_already_closed':
        return 'El caso ya se encuentra cerrado'
      // Triage Intelligence
      case 'triage_disabled':
        return 'Triage Intelligence no está habilitado para tu empresa'
      case 'triage_no_enabled_rules':
        return 'No hay reglas de Triage Intelligence habilitadas. Contactá a soporte para configurarlas'
      case 'triage_rules_invalid':
        return 'Hay reglas de Triage Intelligence con configuración inválida. Contactá a soporte para revisarlas'
      case 'triage_missing_mapping':
        return 'La importación de Triage Intelligence no está configurada. Contactá a soporte'
      case 'triage_execution_in_progress':
        return 'Ya hay una importación en curso. Esperá a que termine para importar otro archivo'
      case 'triage_execution_enqueue_failed':
        return 'No se pudo iniciar la importación. Intentá nuevamente en unos minutos'
      case 'triage_execution_not_found':
        return 'La importación no existe'
      case 'triage_match_not_found':
        return 'El resultado no existe'
      case 'triage_match_not_confirmable':
        return 'Solo se pueden confirmar resultados en borrador. Refrescá la bandeja'
      case 'triage_match_not_retryable':
        return 'Solo se pueden reintentar resultados con error al crear el caso. Refrescá la bandeja'
      case 'triage_match_not_discardable':
        return 'Solo se pueden desestimar borradores o resultados con error. Refrescá la bandeja'
      case 'triage_missing_required_column':
        return 'Al registro le faltan datos obligatorios para crear el caso'
      case 'triage_case_creation_error':
        return 'No se pudo crear el caso. Intentá nuevamente en unos minutos'
      case 'case_request_in_trash':
        return 'Ya existe un caso para este siniestro en la papelera'
      case 'not_found_instance':
        return 'La instancia configurada ya no existe'
      case 'not_found_reason':
        return 'El motivo de análisis configurado ya no existe'
      case 'not_found_sinister_type':
        return 'El tipo de siniestro configurado ya no existe'
      case 'not_found_sinister':
        return 'La aseguradora no encontró el siniestro'
      case 'invalid_sinister_format':
        return 'El número de siniestro no tiene un formato válido'
      case 'integration_error':
        // Riesgo Online / IRIS errors name the integration that answered and refused
        // the operation; retrying won't fix them. Rivadavia's crawler failures carry
        // no detail and are transient.
        return err?.response?.data?.errors?.[0]?.integration
          ? 'La integración rechazó la solicitud. Si el problema persiste, contactá a soporte.'
          : 'La integración con la aseguradora no respondió. Intentá nuevamente en unos minutos'
      case 'webhook_creation_failed':
        return 'No se pudo crear el webhook en Autoinspector.'

      case 'invalid_template_name':
        return 'El nombre del template no es válido'

      case 'template_name_already_registered':
        return 'Ya existe un template con este nombre para la compañía'

      case 'template_not_found':
        return 'El template no fue encontrado'

      case 'company_api_key_not_configured':
        return 'La compañía no tiene una API key configurada para Autoinspector'

      case 'autoinspector_list_templates_failed':
        return 'No se pudieron obtener los templates de Autoinspector'

      case 'autoinspector_retrieve_template_failed':
        return 'No se pudo obtener la plantilla desde Autoinspector'

      case 'autoinspector_field_not_found':
        return 'Uno de los campos ya no existe en la plantilla de Autoinspector'

      case 'autoinspector_field_stage_not_supported':
        return 'Uno de los campos no se completa al crear la inspección'

      case 'autoinspector_field_type_incompatible':
        return 'Una de las variables no es compatible con el tipo de su campo'

      case 'not_found_insurance_agent':
        return 'No se encontró el productor'

      case 'not_found_vehicle':
        return 'No se encontró el vehículo'

      case 'enargas_gnc_query_disabled':
        return 'La consulta a ENARGAS se encuentra momentáneamente deshabilitada'

      case 'gnc_query_already_in_progress':
        return 'Ya hay una consulta a ENARGAS en curso para este vehículo'

      case 'gnc_query_already_performed':
        return 'Este vehículo ya tiene una consulta de GNC registrada'

      case 'gnc_daily_limit_reached':
        return 'Ya se consultó ENARGAS para este vehículo hoy.'

      case 'vehicle_gnc_enqueue_failed':
        return 'No se pudo encolar la consulta a ENARGAS. Intenta nuevamente.'

      case 'enargas_unavailable':
        return 'ENARGAS no está disponible en este momento'

      case 'enargas_captcha_unavailable':
        return 'No se pudo generar la validación anti-robots para consultar ENARGAS'

      case 'enargas_captcha_rejected':
        return 'ENARGAS rechazó la validación anti-robots de la consulta'

      // Legacy: no longer emitted, kept for messages already sitting in
      // the DLQ and for clients holding an older response.
      case 'enargas_captcha_failed':
        return 'No se pudo validar la consulta contra ENARGAS'

      case 'enargas_parse_error':
        return 'La respuesta de ENARGAS no pudo ser interpretada'

      case 'not_found_inspection':
        return 'No se encontró la inspección del vehículo'

      case 'invalid_role':
        return 'Tu rol no tiene permisos para realizar esta acción'

      // OAuth 2.0 (conexión de aplicaciones como Piramid)
      case 'invalid_token':
        return 'La conexión con Kach expiró o fue revocada. Volvé a conectar tu cuenta.'

      case 'insufficient_scope':
        return 'La aplicación conectada no tiene permiso para realizar esta acción.'

      case 'human_actor_required':
        return 'Esta acción requiere un usuario, no una credencial de sistema.'

      case 'conflicting_credentials':
        return 'La solicitud mezcla dos formas de autenticación. Usá solo una.'

      case 'in_behalf_not_allowed':
        return 'No se puede indicar un usuario en nombre de quien actuar con un token de conexión.'

      case 'in_behalf_disabled':
        return 'La aseguradora ya no admite operar en nombre de un usuario con clave de API. Conectá tu cuenta de Kach.'

      case 'oauth_invalid_client':
      case 'oauth_client_not_found':
        return 'La aplicación que solicita acceso no está registrada.'

      case 'oauth_invalid_redirect_uri':
        return 'La dirección de retorno de la aplicación no está autorizada.'

      case 'oauth_grant_not_found':
        return 'No encontramos la conexión indicada.'

      case 'oauth_request_not_found':
        return 'La solicitud de autorización no existe o ya fue resuelta.'

      case 'oauth_request_expired':
        return 'La solicitud de autorización venció. Volvé a iniciar la conexión desde Piramid.'

      case 'oauth_request_foreign':
        return 'La solicitud de autorización no fue iniciada desde esta sesión.'

      case 'oauth_request_already_decided':
        return 'La solicitud de autorización ya fue resuelta.'

      case 'invalid_origin':
        return 'El origen de la solicitud no está permitido.'

      case 'system_user_not_found':
        return 'Falta el usuario sistema de Kach. Contactá a soporte.'

      case 'oauth_invalid_request':
      case 'oauth_invalid_grant':
      case 'oauth_unauthorized_client':
      case 'oauth_unsupported_grant_type':
      case 'oauth_invalid_scope':
      case 'oauth_access_denied':
      case 'oauth_unsupported_response_type':
        return 'La solicitud de autorización no es válida.'

      // Actividad de usuarios / analistas
      case 'company_required':
        return 'Tu usuario no está asociado a ninguna empresa'

      case 'users_required':
        return 'Seleccioná al menos un usuario para ver su actividad'

      case 'too_many_users':
        return 'Seleccionaste demasiados usuarios para comparar a la vez'

      case 'too_many_event_types':
        return 'Seleccionaste demasiados tipos de evento'

      case 'invalid_weekday':
        return 'El día de la semana seleccionado no es válido'

      case 'invalid_date_range':
        return 'El rango de fechas seleccionado no es válido'

      case 'date_range_too_large':
        return 'El rango de fechas es demasiado amplio'

      case 'invalid_timezone_offset':
        return 'No se pudo determinar tu zona horaria'

      case 'analyst_not_found':
        return 'No se encontró el analista en tu empresa'

      case 'target_group_required':
        return 'Seleccioná un grupo para comparar'

      case 'target_group_not_found':
        return 'No se encontró el grupo seleccionado'

      case 'empty_benchmark_population':
        return 'No hay analistas con actividad para comparar en este período'

      case 'cannot_read_comparative_users_activity':
        return 'Tu rol no tiene permisos para comparar la actividad de otros usuarios'

      case 'delegation_invalid_filter':
        return 'Los filtros por responsable, colaborador o alcance no se pueden usar para delegar casos'

      case 'delegation_no_eligible_recipients':
        return 'Ninguno de los destinatarios seleccionados puede recibir casos'

      case 'delegation_no_matching_cases':
        return 'No hay casos que cumplan los filtros seleccionados'

      case 'delegation_preview_outdated':
        return 'Los casos a delegar cambiaron desde la vista previa. Revisá el resumen actualizado antes de confirmar'

      case 'delegation_group_already_restored':
        return 'Esta delegación ya fue restaurada'

      case 'not_found_case_delegation_group':
        return 'No se encontró la delegación'

      case 'member_not_found':
        return 'No se encontró el usuario en tu empresa'

      case 'machine_actor_required':
        return 'Esta operación solo la puede hacer una integración'

      case 'participants_sinister_mismatch':
        return 'El siniestro no coincide con el del caso'

      default:
        return 'Ocurrió un error inesperado'
    }
  }, [])

  const toast = useToast()

  const handleError = useCallback((err: any) => {
    console.log('toast executed')

    toast({
      title: getErrorMessage(err),
      status: 'error',
    })
  }, [])

  return {
    handleError,
    getErrorMessage,
  }
}
